<style src="./ModalStages.scss" lang="scss"></style>
<template>
  <div class="stages">
    <ul class="list">
      <li
        class="item"
        v-for="(stage, stageIdx) in value"
        :key="stageIdx"
        :title="stage.text">

        {{ stage.text }}
        <div
          class="remove"
          @click="removeUser(stageIdx)">
          X
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { IconUser } from '@/components/primitives/icons'

export default {
  name: 'ModalStages',
  components: {
    IconUser
  },
  props: {
    value: {
      default: null
    }
  },
  methods: {
    removeUser (userIdx) {
      const list = [...this.value]
      list.splice(userIdx, 1)
      this.$emit('input', list)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/view/board/components/modal-stages/ModalStages.vue